/* atolea — gaveta do carrinho (replica da gaveta do Prestige dele, sections/cl-cart-drawer).
   Abre no icone do carrinho e ao adicionar produto: intercepta TODO form de /cart/add na fase de
   captura (antes do product-form do Shrine), posta por /cart/add.js e redesenha por /cart.js.
   Upsell: produtos da colecao configurada que ainda NAO estao no carrinho, um por vez (setas,
   toque e arraste), com seletor de variante e Add. Sem timer (nota do operador). */
(function () {
  'use strict';
  var D, O, money = 'R$ {{amount_with_comma_separator}}', cart = null, ups = [];
  function fmt(c) {
    var n = (c || 0) / 100, a = n.toFixed(2);
    return money
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, a.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(n)))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(n)))
      .replace(/\{\{\s*amount\s*\}\}/, a.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var MINUS = '<svg viewBox="0 0 10 2" width="10" height="2" aria-hidden="true"><path d="M0 1h10" stroke="currentColor" stroke-width="1.4"/></svg>';
  var PLUS = '<svg viewBox="0 0 10 10" width="10" height="10" aria-hidden="true"><path d="M0 5h10M5 0v10" stroke="currentColor" stroke-width="1.4"/></svg>';

  function bubble(count) {
    document.querySelectorAll('#cart-icon-bubble, a[href$="/cart"].header__icon, .header__icon--cart').forEach(function (b) {
      var c = b.querySelector('.cart-count-bubble');
      if (!count) { if (c) c.remove(); return; }
      if (!c) { c = document.createElement('div'); c.className = 'cart-count-bubble'; b.appendChild(c); }
      c.innerHTML = '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + ' items</span>';
    });
  }
  function tier(total) {
    var t = +D.getAttribute('data-tier'), box = D.querySelector('[data-cl-tier]');
    if (!t || !box) return;
    box.hidden = false;
    var missing = Math.max(0, t - total);
    D.querySelector('[data-cl-tier-fill]').style.width = Math.min(100, total / t * 100) + '%';
    D.querySelector('[data-cl-tier-msg]').innerHTML = missing ? esc(D.getAttribute('data-tier-text')).replace('[amount]', '<strong>' + esc(fmt(missing)) + '</strong>') : 'Congratulations! You unlocked ' + esc(D.getAttribute('data-tier-label')) + '!';
    D.querySelector('[data-cl-tier-label]').innerHTML = 'Spend ' + esc(fmt(t).replace(/[,.]00$/, '')) + ', <strong>' + esc(D.getAttribute('data-tier-label')) + '</strong>';
  }
  function upsell(items) {
    var host = D.querySelector('[data-cl-upsell]'), track = D.querySelector('[data-cl-up-track]');
    if (!host || !track) return;
    var inCart = {}; items.forEach(function (it) { inCart[it.product_id] = 1; });
    var list = ups.filter(function (p) { return p && !inCart[p.id]; }).slice(0, 10);
    host.hidden = !list.length;
    track.innerHTML = list.map(function (p) {
      var avail = p.variants.filter(function (v) { return v.available; });
      var v0 = avail[0] || p.variants[0];
      var sel = p.variants.length > 1 && !(p.variants.length === 1 && p.variants[0].title === 'Default Title')
        ? '<select data-cl-up-var aria-label="Variant">' + avail.map(function (v) { return '<option value="' + v.id + '" data-price="' + v.price + '">' + esc(v.title) + '</option>'; }).join('') + '</select>' : '';
      return '<div class="clcd__up"><a href="' + esc(p.url) + '"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy"></a>' +
        '<div class="clcd__up-info"><a class="clcd__up-title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<p class="clcd__up-price" data-cl-up-price>' + fmt(v0.price) + '</p>' +
        '<div class="clcd__up-row">' + sel + '<button type="button" class="clcd__up-add" data-cl-up-add="' + v0.id + '">Add</button></div></div></div>';
    }).join('');
  }
  function render(c) {
    if (!D || !c) return;
    cart = c;
    var items = c.items || [];
    D.classList.toggle('is-empty', !c.item_count);
    D.querySelectorAll('[data-cl-cart-count]').forEach(function (e) { e.textContent = c.item_count; });
    D.querySelector('[data-cl-cart-items]').innerHTML = items.map(function (it, i) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.name !== 'Title' && o.value !== 'Default Title'; }).map(function (o) { return esc(o.value); }).join(' / ');
      var props = it.properties ? Object.keys(it.properties).filter(function (k) { return k.charAt(0) !== '_' && it.properties[k]; })
        .map(function (k) { return '<p class="clcd__prop">' + esc(k) + ': ' + esc(it.properties[k]) + '</p>'; }).join('') : '';
      var price = (it.original_line_price > it.final_line_price ? '<s>' + fmt(it.original_line_price) + '</s>' : '') + fmt(it.final_line_price);
      return '<div class="clcd__item" data-line="' + (i + 1) + '">' +
        '<a class="clcd__img" href="' + esc(it.url) + '" tabindex="-1"><img src="' + esc(img(it.image, 240)) + '" alt="' + esc(it.product_title) + '" loading="lazy"></a>' +
        '<div class="clcd__info"><a class="clcd__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        '<p class="clcd__price">' + price + '</p>' + (opts ? '<p class="clcd__variant">' + opts + '</p>' : '') + props +
        '<div class="clcd__ctrl"><div class="clcd__qty">' +
        '<button type="button" data-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity">' + MINUS + '</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-q="' + (it.quantity + 1) + '" aria-label="Increase quantity">' + PLUS + '</button></div>' +
        '<button type="button" class="clcd__remove" data-q="0">Remove</button></div></div></div>';
    }).join('');
    D.querySelectorAll('[data-cl-cart-total]').forEach(function (e) { e.textContent = fmt(c.total_price); });
    tier(c.total_price);
    upsell(items);
    bubble(c.item_count);
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function refresh() { return getCart().then(function (c) { render(c); return c; }); }
  function open() {
    if (!D) return;
    D.classList.add('is-open'); O.classList.add('is-open'); D.setAttribute('aria-hidden', 'false');
    document.body.classList.add('clcd-lock');
    setTimeout(function () { D.focus(); }, 50);
  }
  function close() {
    if (!D) return;
    D.classList.remove('is-open'); O.classList.remove('is-open'); D.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('clcd-lock');
  }
  function change(line, q) {
    D.classList.add('is-busy');
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: Math.max(0, q) }) })
      .then(function (r) { return r.json(); }).then(render).catch(refresh).then(function () { D.classList.remove('is-busy'); });
  }
  function add(body, isForm) {
    return fetch('/cart/add.js', { method: 'POST', headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function upStep(dir) {
    var tr = D.querySelector('[data-cl-up-track]'); if (!tr) return;
    tr.scrollBy({ left: dir * tr.clientWidth, behavior: 'smooth' });
  }
  function dragTrack() {
    var tr = D.querySelector('[data-cl-up-track]'); if (!tr) return;
    var down = false, sx = 0, sl = 0, moved = false;
    tr.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = tr.scrollLeft; tr.style.scrollSnapType = 'none'; });
    window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 5) moved = true; tr.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false;
      var w = tr.clientWidth, t = Math.round(tr.scrollLeft / w) * w;
      tr.scrollTo({ left: t, behavior: 'smooth' }); setTimeout(function () { tr.style.scrollSnapType = ''; }, 350);
    });
    tr.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }
  function init() {
    D = document.getElementById('ClCartDrawer'); O = document.getElementById('ClCartOverlay');
    if (!D) return;
    money = D.getAttribute('data-money') || money;
    try { ups = JSON.parse(D.querySelector('[data-cl-upsell-json]').textContent) || []; } catch (e) { ups = []; }
    window.ClCart = { open: function () { refresh().then(open); }, close: close, refresh: refresh };
    dragTrack();
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-cl-cart-close]')) { close(); return; }
      var ic = t.closest('#cart-icon-bubble, a[href$="/cart"], a[href="/cart"]');
      if (ic && !t.closest('#ClCartDrawer')) { e.preventDefault(); e.stopPropagation(); refresh().then(open); return; }
      var q = t.closest('#ClCartDrawer [data-q]');
      if (q) { var it = q.closest('[data-line]'); change(+it.getAttribute('data-line'), +q.getAttribute('data-q')); return; }
      var u = t.closest('#ClCartDrawer [data-cl-up]');
      if (u) { upStep(+u.getAttribute('data-cl-up')); return; }
      var a = t.closest('#ClCartDrawer [data-cl-up-add]');
      if (a) {
        var s = a.parentNode.querySelector('[data-cl-up-var]');
        a.disabled = true;
        add(JSON.stringify({ items: [{ id: +(s ? s.value : a.getAttribute('data-cl-up-add')), quantity: 1 }] }))
          .then(refresh).catch(function (err) { alert((err && (err.description || err.message)) || 'Error'); })
          .then(function () { a.disabled = false; });
      }
    }, true);
    D.addEventListener('change', function (e) {
      var s = e.target.closest('[data-cl-up-var]'); if (!s) return;
      var o = s.options[s.selectedIndex], p = s.closest('.clcd__up').querySelector('[data-cl-up-price]');
      if (o && p) p.textContent = fmt(+o.getAttribute('data-price'));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.getAttribute || (f.getAttribute('action') || '').indexOf('/cart/add') < 0 || e.defaultPrevented) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var btn = e.submitter; if (btn) btn.setAttribute('aria-busy', 'true');
      add(new FormData(f), true).then(function () { return refresh(); }).then(open)
        .catch(function (err) { alert((err && (err.description || err.message)) || 'Error'); })
        .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
    }, true);
    document.addEventListener('cl:cart:added', function () { refresh().then(open); });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
